/**
 * Formats a session count for display, pluralizing "session" and localizing the number.
 * Shared between the /copilot/agents and repo agents pages so the copy stays consistent.
 */
export function formatSessionCount(count: number): string {
  return count === 1 ? '1 session' : `${count.toLocaleString()} sessions`
}
